<template>
  <main class="rb-legal-page" dir="rtl">
    <nav class="rb-legal-page-nav" aria-label="اسناد و بازگشت">
      <router-link v-for="id in ['terms', 'privacy']" :key="id" :to="documentRoute(id)">{{ id === 'terms' ? 'شرایط استفاده' : 'حریم خصوصی' }}</router-link>
      <router-link :to="{name: 'portalHome', params: {lang}}">بازگشت به حساب</router-link>
    </nav>
    <p v-if="lang !== 'fa'" lang="en" dir="ltr">The Persian document is displayed below.</p>
    <legal-document v-if="document" :document-id="document.id"/>
    <p v-else role="status">این سند پیدا نشد. از پیوندهای بالای صفحه استفاده کنید.</p>
  </main>
</template>

<script>
import LegalDocument from '@/components/legal/LegalDocument.vue'
import {getLegalDocument} from '@/legal/documents'

export default {
  name: 'LegalDocumentPage',
  components: {LegalDocument},
  computed: {
    lang() {return this.$route.params.lang || 'fa'},
    document() {return getLegalDocument(this.$route.params.documentId)},
  },
  methods: {documentRoute(documentId) {return {name: 'legalDocument', params: {lang: this.lang, documentId}}}},
}
</script>

<style scoped>
.rb-legal-page{max-width:920px;margin:0 auto;padding:32px 24px 64px;background:#fff;min-height:100vh}
.rb-legal-page-nav{display:flex;flex-wrap:wrap;gap:16px;margin-bottom:28px;line-height:1.8}
.rb-legal-page-nav a{color:#087a79}
@media(max-width:600px){.rb-legal-page{padding:20px 16px 40px}}
</style>
